export default __webpack_public_path__ + "static/media/affiliate-commission-banner.b1d75a60.webp";